(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/collections/results.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/collections/results.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.collections = svs.matchen.collections || {};

  svs.matchen.collections.Results = Backbone.Collection.extend({
    model: function() {
      return svs.matchen.models.Result;
    },

    initialize: function() {
      this.logger = new svs.core.log.Logger('svs.matchen.collections.Results');
    },

    addResultsFromOutcomes: function(options) {
      options = _.defaults({}, options, {
        homeOutcomes: [],
        awayOutcomes: [],
        xpertenResults: [],
        rowPrices: []
      });

      this.set(this.getParsedResults(options));
    },

    getParsedResults: function(options) {
      var models = [];

      options = _.defaults({}, options, {
        homeOutcomes: [],
        awayOutcomes: [],
        xpertenResults: []
      });

      if (options.homeOutcomes.length && options.awayOutcomes.length) {
        models = this.getParsedOutcomesResults(
          options.homeOutcomes,
          options.awayOutcomes
        );
      } else if (options.xpertenResults && options.xpertenResults.length) {
        models = this.getParsedXpertenResults(
          options.xpertenResults,
          options.rowPrices
        );
      }

      return models;
    },

    getMaxNumberOfResults: function() {
      return Math.max(
        this.getHomeResults().length,
        this.getDrawResults().length,
        this.getAwayResults().length
      );
    },

    removeHomeResults: function() {
      this.remove(this.getHomeResults());
    },

    removeDrawResults: function() {
      this.remove(this.getDrawResults());
    },

    removeAwayResults: function() {
      this.remove(this.getAwayResults());
    },

    getHomeResults: function() {
      return this.filter(function(result) {
        return result.isHomeWin();
      });
    },

    getDrawResults: function() {
      return this.filter(function(result) {
        return result.isDraw();
      });
    },

    getAwayResults: function() {
      return this.filter(function(result) {
        return result.isAwayWin();
      });
    },

    getParsedOutcomesResults: function(homeOutcomes, awayOutcomes) {
      var models = [];
      var Model = _.result(this, 'model');
      var homeResults = this.getHomeResultsFromOutcomes(
        homeOutcomes,
        awayOutcomes
      );
      var drawResults = this.getDrawResultsFromOutcomes(
        homeOutcomes,
        awayOutcomes
      );
      var awayResults = this.getAwayResultsFromOutcomes(
        homeOutcomes,
        awayOutcomes
      );

      _.each(
        [homeResults, drawResults, awayResults],
        function(results) {
          _.each(results, function(result) {
            models.push(new Model(result));
          });
        },
        this
      );

      return models;
    },

    getParsedXpertenResults: function(results, rowPrices) {
      var models = [];
      var Model = _.result(this, 'model');
      var hasPrice = rowPrices.length != 0;

      _.each(
        results,
        function(result, index) {
          try {
            models.push(new Model({
              home: parseInt(result[0], 10),
              away: parseInt(result[1], 10),
              price: hasPrice ? rowPrices[index] : ''
            }));
          } catch (e) {
            this.logger('Error when using parseInt()', result);
          }
        },
        this
      );

      return models;
    },

    getHomeResultsFromOutcomes: function(
      selectedHomeOutcomes,
      selectedAwayOutcomes
    ) {
      return this.getResultsFromOutcomes(
        selectedHomeOutcomes,
        selectedAwayOutcomes,
        '>'
      );
    },

    getAwayResultsFromOutcomes: function(
      selectedHomeOutcomes,
      selectedAwayOutcomes
    ) {
      return this.getResultsFromOutcomes(
        selectedHomeOutcomes,
        selectedAwayOutcomes,
        '<'
      );
    },

    getDrawResultsFromOutcomes: function(
      selectedHomeOutcomes,
      selectedAwayOutcomes
    ) {
      return this.getResultsFromOutcomes(
        selectedHomeOutcomes,
        selectedAwayOutcomes,
        '=='
      );
    },

    getResultsFromOutcomes: function(homeOutcomes, awayOutcomes, comparator) {
      var results = [];
      var home;
      var away;

      try {
        for (var i = 0; i < homeOutcomes.length; i++) {
          home = parseInt(homeOutcomes[i], 10);
          for (var j = 0; j < awayOutcomes.length; j++) {
            away = parseInt(awayOutcomes[j], 10);
            if (comparator == '>' && home > away) {
              results.push({ home: home, away: away });
            } else if (comparator == '==' && home == away) {
              results.push({ home: home, away: away });
            } else if (comparator == '<' && home < away) {
              results.push({ home: home, away: away });
            }
          }
        }
      } catch (e) {
        this.logger.error(
          'Error when using parseInt()',
          e,
          homeOutcomes,
          awayOutcomes
        );
      }
      return results;
    },

    hasResult: function(result) {
      if (result instanceof svs.matchen.models.Result) {
        return this.findWhere({
          home: result.getHomeResult(),
          away: result.getAwayResult()
        });
      }
    },

    selectResult: function(result) {
      var foundResult;

      if (result instanceof svs.matchen.models.Result) {
        foundResult = this.hasResult(result);

        if (foundResult) {
          foundResult.setSelected(true);
        }
      }
    },

    toString: function() {
      return this.map(function(result) {
        return result.getHomeResult() + '-' + result.getAwayResult();
      }).join(' ');
    },

    comparator: function(resultA, resultB) {
      return resultA.compareTo(resultB);
    }
  });
})(Backbone, _, svs);


 })(window);